import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'number_off_site_housing_sites_occupied_workers_managed_1'

export const dataPointDefinition = {
  retracedId: 'number_off_site_housing_sites_occupied_workers_managed_1',
  name: 'Number of off-site housing sites occupied by workers managed or controlled by the facility:',
  description:
    'Off-site housing means any type of accommodation including dormitory and other residential building, flat, apartment, or room. ',
  meta: {
    slcpMeta: {
      key: 'fp-bui-4',
      number: 'FP-BUI-6',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {type: 'object', properties: {value: {type: 'string'}}, required: ['value']},
  externalIds: [{id: 'fp-bui-4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27270,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
